<template>
  <validation-observer ref="registerForm" >
    <b-form class="auth-register-form mt-2" @submit.prevent="validationForm">
      <b-form-group label="User name" label-for="username">
        <validation-provider
          #default="{ errors }"
          name="username"
        >
          <b-form-input
            id="username"
            v-model="username"
            :state="errors.length > 0 ? false : null"
            name="register-username"
            placeholder="johndoe"
            autocomplete="on"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <div class="d-flex justify-content-between flex-wrap">
        <b-col class="d-flex pl-0 pr-md-50 pr-0" md="6" cols="12">
          <!-- firstname -->
          <b-form-group label="First name" label-for="firstname" class="w-100">
            <validation-provider
              #default="{ errors }"
              name="First name"
              rules="required"
            >
              <b-form-input
                id="firstname"
                v-model="firstName"
                :state="errors.length > 0 ? false : null"
                name="register-firstname"
                placeholder="john"
                autocomplete="on"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col class="d-flex pr-0 pl-md-50 pl-0" md="6" cols="12">
          <!-- lastname -->
          <b-form-group label="Last name" label-for="lastname" class="w-100">
            <validation-provider
              #default="{ errors }"
              name="Last name"
              rules="required"
            >
              <b-form-input
                id="lastname"
                v-model="lastName"
                :state="errors.length > 0 ? false : null"
                name="register-lastname"
                placeholder="doe"
                autocomplete="on"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </div>
      <b-form-group label-for="nationality" class="w-100" label="nationality">
        <countries-select
          v-model="nationality"
          label="text"
          select="id"
          url="country"
          searchable
        />
      </b-form-group>
      <!-- gender -->
      <b-form-group label-for="gender" class="w-100" label="gender">
        <v-select
          v-model="gender"
          label="name"
          class="w-100"
          :options="genderOption"
        />
      </b-form-group>
      <!-- email -->
      <b-form-group label="Email" label-for="email">
        <validation-provider
          #default="{ errors }"
          name="Email"
          rules="required|email"
        >
          <b-form-input
            id="email"
            v-model="regEmail"
            :state="errors.length > 0 ? false : null"
            name="register-email"
            placeholder="john@example.com"
            autocomplete="on"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <div class="d-flex justify-content-between flex-wrap">
        <b-col class="d-flex pl-0 pr-md-50 pr-0" md="6" cols="12">
          <!-- password -->
          <b-form-group label="Password" label-for="password" class="w-100">
            <validation-provider
              #default="{ errors }"
              name="Password"
              rules="required|min:8|password"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="password"
                  v-model="password"
                  :type="passwordFieldType"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                  name="register-password"
                  placeholder="············"
                  autocomplete="on"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIcon"
                    class="cursor-pointer"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col class="d-flex pr-0 pl-md-50 pl-0" md="6" cols="12">
          <b-form-group
            label="Confirm Password"
            label-for="cpassword"
            class="w-100"
          >
            <validation-provider
              #default="{ errors }"
              name="Confirm password"
              :rules="`required|min:8|password|confirmed:${password}`"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="cpassword"
                  v-model="passwordConfirmation"
                  :type="cpasswordFieldType"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                  name="register-cpassword"
                  placeholder="············"
                  autocomplete="on"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="cpasswordToggleIcon"
                    class="cursor-pointer"
                    @click="toggleCpasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </div>
      <b-button
        class="gradient-btn py-2"
        block
        type="submit"
      >
        Sign up
      </b-button>
    </b-form>
    <loader :loading="loading" />
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BCol,
} from "bootstrap-vue";
import vSelect from "vue-select";

import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import CountriesSelect from "./CountriesSelect.vue";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    Loader,
    CountriesSelect,
    BCol,
    vSelect,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      regEmail: "",
      username: "",
      password: "",
      passwordConfirmation: "",
      firstName: "",
      lastName: "",
      status: "",
      nationality: "",
      gender: "",
      loading: false,
      // validation rules
      required,
      email,
      genderOption: [
        { name: "Unknown", value: "UNKNOWN" },
        { name: "Male", value: "MALE" },
        { name: "Female", value: "FEMALE" },
      ],
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    cpasswordToggleIcon() {
      return this.cpasswordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    validationForm() {
      this.$refs.registerForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            const { data } = await this.$http.post("auth/user/register", {
              first_name: this.firstName,
              last_name: this.lastName,
              email: this.regEmail.toLowerCase(),
              password: this.password,
              password_confirmation: this.passwordConfirmation,
              user_name: this.username,
              nationality_id: this.nationality,
              gender: this.gender.value,
            });
            this.$http.defaults.headers.common["Authorization"] =
              await `${data.type} ${data.token}`;
            await localStorage.setItem(
              "userData",
              JSON.stringify({
                ...data.user,
                email_verified: data.email_verified,
                type: data.abilities[0].includes("admin") ? "admin" : "user",
              })
            );
            await this.$store.dispatch("auth/setUserData", {
              ...data.user,
              email_verified: data.email_verified,
              type: data.abilities[0].includes("admin") ? "admin" : "user",
            });
            await localStorage.setItem(
              "token",
              JSON.stringify({ val: data.token, type: data.type })
            );
            if (data.email_verified) {
              let wantToRegister = localStorage.getItem("wantToRegister");
              this.$router.push(
                wantToRegister
                  ? { name: "show-competition", params: { id: wantToRegister } }
                  : { name: "user-dashboard" }
              );
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Welcome ${
                    data.user.first_name + " " + data.user.last_name
                  }`,
                  icon: "CoffeeIcon",
                  variant: "success",
                  text: `You have successfully logged in as ${
                    data.user.first_name + " " + data.user.last_name
                  }. Now you can start to explore!`,
                },
              });
            } else {
              this.$router.push({ name: "auth-user-email-verify" });
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Welcome ${
                    data.user.first_name + " " + data.user.last_name
                  }`,
                  icon: "CoffeeIcon",
                  variant: "warning",
                  text: `Please, verify your email !`,
                },
              });
            }
          } catch (err) {}

          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
